import { messaging } from "../firebase-config.js";
import { getToken, onMessage } from "firebase/messaging";
import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);

// VAPID Key (Web Push Certificate) - Configurable
// VAPID Key: Managed via Firebase Console or passed dynamically
// const VAPID_KEY = "BL2B4tF.....";

export const PushNotificationService = {
    /**
     * Request Permission and Get Token
     * @param {string} uid - User ID to save token against
     * @param {string} vapidKey - Optional VAPID Key from Firebase Console
     */
    async requestAndSaveToken(uid, vapidKey = null) {
        try {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
                console.log('Notification permission granted.');

                // [FIX] Use Main Service Worker (sw.js)
                // We must pass the registration to getToken to avoid it looking for firebase-messaging-sw.js
                const registration = await navigator.serviceWorker.ready;

                // Get Token
                const options = {
                    serviceWorkerRegistration: registration
                };
                if (vapidKey) options.vapidKey = vapidKey;

                const token = await getToken(messaging, options);

                if (token) {
                    console.log('FCM Token:', token);
                    await this.saveToken(uid, token);
                    return token;
                } else {
                    console.log('No registration token available. Request permission to generate one.');
                    return null;
                }
            } else {
                console.log('Unable to get permission to notify.');
                return null;
            }
        } catch (err) {
            console.error('An error occurred while retrieving token. ', err);
            // Don't throw, just return null to prevent app crash
            return null;
        }
    },

    /**
     * Save Token to Firestore
     */
    async saveToken(uid, token) {
        if (!uid || !token) return;

        try {
            // 1. Save to Firestore
            const tokenRef = doc(db, 'users', uid, 'fcm_tokens', token);
            await setDoc(tokenRef, {
                token: token,
                lastUpdated: serverTimestamp(),
                platform: 'web'
            });
            console.log('Token saved to Firestore');

            // 2. Subscribe to Global Topic (SCALABILITY)
            try {
                const { getFunctions, httpsCallable } = await import("firebase/functions");
                const functions = getFunctions(app);
                const subscribeToTopic = httpsCallable(functions, 'subscribeToTopic');

                await subscribeToTopic({ token, topic: 'all_global' });
                console.log('Subscribed to all_global topic');
            } catch (topicError) {
                console.error('Topic subscription failed (Non-blocking):', topicError);
            }

        } catch (error) {
            console.error('Error saving token to Firestore:', error);
        }
    },

    /**
     * Listen for foreground messages
     */
    listen() {
        onMessage(messaging, (payload) => {
            console.log('Message received. ', payload);
            // Customize foreground notification here
            // e.g., Show a Toast or Custom Modal

            // Or sweet alert / toast
            if (window.Modal && window.Modal.alert) {
                // Simple alert for now, or Toast if available
                // window.Modal.alert(payload.notification.title, payload.notification.body);
            }
        });
    }
};
